import React, { useState } from "react"
import {
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material"
import { Box, styled } from "@mui/system"
import { useTheme } from "@emotion/react"
import AppButton from "components/StyledComponents/AppButton"
import trashIcon from "assets/icons/trash.svg"
import { Table } from "react-bootstrap"
import { useDispatch } from "react-redux"
import { deleteRestaurantGroupAction } from "redux/DMV/actions/user"
import DeleteConfirmationDialog from "components/DeleteConfirmationDialog"
import { DMVActions } from "redux/DMV/slice/user"
import { userActions } from "redux/user/user"
import { formatDates } from "helpers/functions"
import { appActions } from "redux/app/slice/app"

const CustomTable = styled(Table)(() => ({
  backgroundColor: "transparent",
  borderRadius: "12px",
  borderCollapse: "collapse !important",
  "& .MuiTableCell-root": {
    padding: "17px 24px 17px 0px",
    backgroundColor: "transparent",
    borderBottom: "none",
    boxSizing: "border-box",
    "&:first-of-type": {
      paddingLeft: 20
    }
  },
  "& .MuiTableRow-root": {
    "&:last-child": {
      borderBottom: "none"
    }
  },
  "& .MuiTableCell-head": {
    position: "relative"
  }
}))
const GroupLeaderBoardTable = ({ columns, rows, currentPage }) => {
  const [open, setOpen] = useState(false)
  const [configId, setConfigId] = useState("")
  const theme = useTheme()
  const dispatch = useDispatch()

  const handleDelete = (id) => {
    setOpen(true)
    setConfigId(id)
  }

  const handleViewClick = async (row) => {
    const restaurant = row?.restaurants_data?.[0]
    const groupId = row?.id

    if (restaurant && groupId) {
      try {
        dispatch(appActions.initFilters())
        await dispatch(userActions.setUserRestaurant(restaurant))
        await dispatch(DMVActions.setGroupId(groupId))
        await new Promise((resolve) => setTimeout(resolve, 0))

        window.location.href = "/marketing/dashboard/leaderboard/group-leaderboard"
      } catch (error) {
        console.error("Error in viewing group", error)
      }
    }
  }

  return (
    <>
      <DeleteConfirmationDialog
        open={open}
        onClose={() => setOpen(false)}
        description="Are you sure you want to delete this group?"
        onDelete={() => {
          setOpen(false)
          dispatch(deleteRestaurantGroupAction(configId))
        }}
      />
      <TableContainer sx={{ maxHeight: 700 }}>
        <CustomTable stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell style={{ width: "20px" }}>
                <Typography
                  variant="body4Regular"
                  color={theme.palette.text.secondary}
                  style={{ opacity: 0.6 }}>
                  #
                </Typography>
              </TableCell>
              {columns?.map((column) => (
                <TableCell key={column.id} align={column.align} style={{ width: column.minWidth }}>
                  <Typography
                    variant="body4Regular"
                    color={theme.palette.text.secondary}
                    style={{ opacity: 0.6 }}>
                    {column.label}{" "}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows?.length ? (
              rows?.map((row) => {
                return (
                  <TableRow key={row.id}>
                    <TableCell>
                      <Typography variant="body1Regular" color={theme.palette.text.primary}>
                        {String(currentPage * 10 - 10 + rows.indexOf(row) + 1).padStart(2, "0")}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body1Regular" color={theme.palette.text.primary}>
                        {row?.name}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body1Regular" color={theme.palette.text.primary}>
                        {formatDates(row?.created_at)}
                      </Typography>
                    </TableCell>
                    <TableCell align="right">
                      {/* <AppButton
                        variant="outlined"
                        styles={{ padding: "5px 20px" }}
                        // onClick={() => console.log("Edit", row)}
                      >
                        Edit
                      </AppButton> */}
                      <AppButton
                        variant="outlined"
                        styles={{ padding: "5px 20px" }}
                        onClick={() => handleViewClick(row)}>
                        View
                      </AppButton>
                      <AppButton
                        variant="outlined"
                        styles={{ padding: "5px 20px", marginLeft: "10px" }}
                        onClick={() => handleDelete(row?.id)}>
                        Delete
                        <img src={trashIcon} style={{ marginLeft: 5, height: 20 }} />
                      </AppButton>
                    </TableCell>
                  </TableRow>
                )
              })
            ) : (
              <TableRow>
                <TableCell colSpan={8}>
                  <Box className="d-flex justify-content-center">
                    <Typography variant="h2" color={theme.palette.text.primary}>
                      {"No Groups Found"}
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </CustomTable>
      </TableContainer>
    </>
  )
}

export default GroupLeaderBoardTable
